import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
const Table = forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(({
  className,
  ...props
}, ref) => <div className="w-full overflow-auto" data-id="element-433">
    <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} data-id="element-434" />
  </div>);
Table.displayName = 'Table';
const TableHeader = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <thead ref={ref} className={cn('[&_tr]:border-b', className)} {...props} data-id="element-435" />);
TableHeader.displayName = 'TableHeader';
const TableBody = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} data-id="element-436" />);
TableBody.displayName = 'TableBody';
const TableFooter = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <tfoot ref={ref} className={cn('bg-neutral-50 font-medium', className)} {...props} data-id="element-437" />);
TableFooter.displayName = 'TableFooter';
const TableRow = forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(({
  className,
  ...props
}, ref) => <tr ref={ref} className={cn('border-b border-neutral-200 transition-colors hover:bg-neutral-50', className)} {...props} data-id="element-438" />);
TableRow.displayName = 'TableRow';
const TableHead = forwardRef<HTMLTableCellElement, React.ThHTMLAttributes<HTMLTableCellElement>>(({
  className,
  ...props
}, ref) => <th ref={ref} className={cn('h-10 px-4 text-left align-middle font-medium text-neutral-700 [&:has([role=checkbox])]:pr-0', className)} {...props} data-id="element-439" />);
TableHead.displayName = 'TableHead';
const TableCell = forwardRef<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>(({
  className,
  ...props
}, ref) => <td ref={ref} className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)} {...props} data-id="element-440" />);
TableCell.displayName = 'TableCell';
const TableCaption = forwardRef<HTMLTableCaptionElement, React.HTMLAttributes<HTMLTableCaptionElement>>(({
  className,
  ...props
}, ref) => <caption ref={ref} className={cn('mt-4 text-sm text-neutral-500', className)} {...props} data-id="element-441" />);
TableCaption.displayName = 'TableCaption';
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };